import type * as React from 'react';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';

import config from 'config/config';
import { getFeatureFlag } from 'data/get-feature-flag';

interface IFeatureFlagContextProvider {
  children: React.ReactNode;
}
interface IFeatureFlagContext {
  featureFlags: { [key: string]: unknown };
}

const FeatureFlagContext = createContext<IFeatureFlagContext>({} as IFeatureFlagContext);
const FeatureFlagContextProvider: React.FC<IFeatureFlagContextProvider> = ({ children }) => {
  const [featureFlags, setFeatureFlag] = useState<{ [key: string]: unknown }>({});

  useEffect(() => {
    if (featureFlags['expertServiceEnabled'] === true) {
      config.expertApi.enabled = true;
    }
  }, [featureFlags]);

  useEffect(() => {
    getFeatureFlag()
      .then(setFeatureFlag)
      .catch((e) => console.warn(`Fail gat feature flag`, e));
  }, []);

  const initialValue = useMemo(() => ({ featureFlags }), [featureFlags]);

  return <FeatureFlagContext.Provider value={initialValue}>{children}</FeatureFlagContext.Provider>;
};
export const useFeatureFlag = (): { featureFlags: { [key: string]: unknown } } => {
  const { featureFlags } = useContext(FeatureFlagContext);
  if (featureFlags === undefined) {
    throw 'feature flag not ready to use';
  }
  return { featureFlags };
};
export default FeatureFlagContextProvider;
